import React from 'react';
import Button from '@material-ui/core/Button';

import * as classes from './dialog-button.module.scss';

export default function DialogButton({ children, onClick }) {
  return (
    <div className={classes.root}>
      <Button
        className={classes.buttonRoot}
        onClick={onClick}
        variant='contained'
      >
        {children}
      </Button>
    </div>
  );
}
